import { render } from "./trSr.vue?vue&type=template&id=5fe7e0de"
import script from "./trSr.vue?vue&type=script&lang=js"
export * from "./trSr.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__